<template>
    <div class="vue timparty-rewards-card rewards-card">
      <div :class="'card h-100 card-catalog card-reward '">

                <span class="badge badge-sm badge-expiring" v-if="isExpiring()"> <img :src="modulePath('/js/src/assets/images/icon-black-timer.png')" class="mr-2"> {{ __('ULTIMA SETTIMANA') }}</span>

                <a v-if="card_link" @click="statsClick(reward)" :href="card_link.url" :target="card_link.target" >
                  <div class="card-img-top bg-cover" :style="card_image != undefined ? 'background-image: url(' + card_image + ')' : ''"></div>
                </a>
                <div v-else class="card-img-top bg-cover" :style="card_image != undefined ? 'background-image: url(' + card_image + ')' : ''"></div>
                <div class="card-body text-left">

                  <div class="reward-sectors">
                    <span class="badge badge-red mb-3" :class="sector_class" v-if="isSpecial()">{{ reward.sector }}</span>
                    <span class="badge badge-accent mb-3" v-else>{{ reward.sector }}</span>
                  </div>


                  <h3 v-html="reward.offerTitle"></h3>
                </div>
                <div class="card-footer">
                  <div v-if="typeof reward.benefitsMessageLabels !== 'undefined' && reward.benefitsMessageLabels.length" class="benefits-message-label btn btn-block mb-2">{{ reward.benefitsMessageLabels[0] }}</div>
                  <a v-if="card_link" @click="statsClick(reward)" :href="card_link.url" :target="card_link.target" class="btn btn-primary btn-lg btn-block">{{ __('SCOPRI DI PIÙ') }}</a>

                  <!--<a href="#" @click.prevent="retrieveReward(reward)">Riscatta da {{ reward.partnerName+' / '+reward.deliveryType + ' (' +  reward.rewardId + ')' }}</a>-->

                </div>
              </div>
    </div>
</template>

<script>

    /* eslint-disable */

    import {isNull, isUndefined} from "lodash";
    import TimPartyMixin         from '../mixins/TimPartyMixin';

    export default {
      name: 'RewardsCard',
      mixins: [ TimPartyMixin ],
      props: {
        reward: {
          type: Object,
          required: true,
        },
        sector_class: String

      },
      data: function(){

        return {

        };
      },
      mounted: function(){

      },

      methods: {
        retrieveReward: function(){
          var self = this;

          var payload = {
            action: 'retrieveReward',
            access_token: this.accessToken,
            reward: this.reward,
          };

          self.loading = true;
          this.callApi( payload, function( response){
            self.loading = false;


          } );
        },

        isSpecial: function(){
          switch (this.reward.sector.toUpperCase()) {
            case this.user.sector_special_name.toUpperCase():
              this.sector_class = 'badge-red';
              return true;
            case "PORTA UN AMICO":
              this.sector_class = 'badge-green';
              return true;

            default:
              return false;
          }
        },

        isExpiring: function(){
          var now = Math.floor(new Date().getTime() / 1000);

          var distance = this.reward.endDate - now;

          return distance < 604800 && this.reward.visibleLabelLastWeek; // 1 week
        },

        statsClick: function(reward){
          this.gtmEvent({event: 'vantaggiClick', eventCategory: 'Click', eventAction: 'Vantaggi', eventLabel: reward.offerTitle})

          this.aaEvent('click', {
                            form: {
                                banner: 'vantaggi-' + this.stripTags(reward.offerTitle),
                                }
                            });

        },


      },

      computed:{
        card_image: function(){
          let card_image;
          let base_path_images = isUndefined(this.user.base_path_images) || isNull(this.user.base_path_images) ? '' : this.user.base_path_images;
          if( _.has( this.reward, 'extra.images.featured' )) {
            card_image = this.reward.extra.images.featured[0];
            card_image = !isNull(card_image) ? base_path_images + card_image : null;
          }
          else if( _.has( this.reward, 'extra.images.slider' )) {
            card_image = this.reward.extra.images.slider[0];
            card_image = !isNull(card_image) ? base_path_images + card_image : null;
          } else {
            card_image = []
          }
          return card_image;

        },
        card_link: function(){
          if(this.reward.template == 'REWARDESTERNO'){
            return {
              url: this.reward.notification.url + '?token=' + this.access_token,
              target: '_blank',
            };
          }
          else if(( this.reward.extra != undefined) && ( this.reward.extra.url != undefined)){

            return {
              url: this.reward.extra.url,
              target: '_self',
            };
          }
          else{
            return null;
          }


        },
      },
    }
  </script>


